export default "/assets/favicon.853cd878.png";